export default __webpack_public_path__ + "static/media/img-3.ecafcc24.jpg";